/* XAPE: keep the pinned "Estimated total" sitting just above the pinned Check out button (sets --xcd-co). */
(function(){
  var raf=0,ro=window.ResizeObserver?new ResizeObserver(sch):null,mo=0;
  function upd(){raf=0;document.querySelectorAll('cart-drawer').forEach(function(d){
    var co=d.querySelector('#CartDrawer-Checkout, .drawer__footer .cart-notification__checkout-button');
    var h=co?Math.round(co.getBoundingClientRect().height):0; if(h) d.style.setProperty('--xcd-co',h+'px');});}
  function sch(){if(!raf)raf=requestAnimationFrame(upd);}
  function watch(){if(ro){ro.disconnect();document.querySelectorAll('cart-drawer #CartDrawer-Checkout').forEach(function(e){ro.observe(e);});}sch();}
  function init(){var d=document.querySelector('cart-drawer');if(!d)return;watch();
    new MutationObserver(function(){clearTimeout(mo);mo=setTimeout(watch,60);}).observe(d,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
